import {Component, OnInit, Output, EventEmitter, Input, OnChanges, SimpleChanges} from '@angular/core';

import {Router} from '@angular/router';
import {CustomTabsService, IconSearch} from 'src/app/admin/event-configuration/services/custom-tabs.service';

@Component({
    selector: 'app-custom-tabs-icons-selection',
    templateUrl: './custom-tabs-icons-selection.component.html',
    styleUrls: ['./custom-tabs-icons-selection.component.scss'],
    standalone: false
})
export class IconSelectionComponent implements OnInit, OnChanges {
  icons;
  name;
  dropdownIcon = false;
  moveToPredefinedIcons;
  @Input() icon;
  @Input() iconType: string;
  @Input() selectedImgPath: string;
  @Input() singleSelectedIconDisplay = false;

  @Output() iconChange = new EventEmitter<IconSearch>();
  predefinedIcons: any[];
  singleSelectedIcon: boolean;

  constructor(
    private service: CustomTabsService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    if (typeof this.selectedImgPath !== 'string') {
      this.singleSelectedIconDisplay = false;
    } else {
      this.singleSelectedIconDisplay = true;
    }
    this.loadIcons();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.name = changes.page?.currentValue ? changes.page.currentValue.name : '';
  }

  loadIcons() {
    this.service.getIcons(this.iconType ? this.iconType : undefined).subscribe(response => {
      this.predefinedIcons = response['results'];
    });
  }

  getIcons() {
    if (this.name) {
      this.service.getIconsByName(this.name).subscribe(e => (this.icons = e));
    } else {
      this.service.getIcons('event').subscribe(e => (this.icons = e));
    }
    if (this.icons) {
      this.dropdownIcon = true;
    } else {
      this.moveToPredefinedIcons = true;
    }
  }

  setIcon(icon) {
    if (!this.singleSelectedIconDisplay) {
      this.name = icon.name;
      this.icon = icon;
      this.iconChange.emit(icon);
    }
  }

  redirectToPredefinedIcons() {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/admin/event-configuration/custom-tabs-icon-create']),
    );
    window.open(url, '_blank');
  }

  resetIcon() {
    this.name = '';
    this.icon = '';
  }

  getClassForIconTile(icon, iconTile, imgPath, index?) {
    if (imgPath && imgPath === iconTile.icon && this.singleSelectedIcon) {
      return 'icon-tile-selected';
    } else if (this.selectedImgPath === index + 1 && !this.singleSelectedIcon) {
      return 'icon-tile-selected';
    } else if (icon && iconTile.id === icon.id) {
      return 'icon-tile-selected';
    } else {
      return 'icon-tile';
    }
  }

  getClassForIconCont(icon, iconTile, imgPath) {
    if (imgPath && imgPath === iconTile.icon) {
      return 'selected-cont';
    } else if (icon && iconTile.id === icon.id) {
      return 'selected-cont';
    } else {
      return 'not-selected-cont';
    }
  }

  changeSelectingIconState() {
    this.singleSelectedIconDisplay = !this.singleSelectedIconDisplay;
  }
}
